import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-bulk-whatsapp',
  templateUrl: './bulk-whatsapp.component.html',
  styleUrls: ['./bulk-whatsapp.component.css']
})
export class BulkWhatsappComponent implements OnInit {
  currentUser: any = {};
  templates: any[] = [];
  selectedTemplate: any = null;
  selectedFile: File | null = null;
  selectedImageFile: File | null = null;
  variables: string[] = [];
  headerImage: string = '';
  headerImageUrl: string = '';
  uploadedImageUrl: string = '';
  imageUploadProgress: number = 0;
  imageUploadType: 'upload' | 'url' = 'upload';
  showLoader: boolean = false;
  campaignName: string = '';
  previewText: string = '';
  templateComponents: any = {
    header: null,
    body: null,
    buttons: null,
    footer: null
  };
  bodyVariables: string[] = [];
  buttonVariables: string[] = [];
  private previewTimeout: any;
  contactsPreview: any[] = [];
  showContactsPreview: boolean = false;
  showConfirmModal: boolean = false;
  uploadErrors: any = [];

  constructor(
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.loadTemplates();
  }

  trackByIndex(index: number): number {
    return index;
  }

  // aaaa

  loadTemplates() {
    this.showLoader = true;
    this.loginservice.getWhatsAppStoredTemplateFromMeta(this.currentUser, 'APPROVED').subscribe(
      data => {
        if (data['status'] === 'success') {
          this.templates = data['data'];
        }
        this.showLoader = false;
      },
      error => {
        this.showLoader = false;
      }
    );
  }

  onTemplateChange() {
    if (this.selectedTemplate) {
      this.parseTemplateComponents();
      this.updatePreview();
    }
  }

  parseTemplateComponents() {
    if (!this.selectedTemplate || !this.selectedTemplate.components) return;

    this.templateComponents = {
      header: null,
      body: null,
      buttons: null,
      footer: null
    };

    this.selectedTemplate.components.forEach((component: any) => {
      switch (component.component_type) {
        case 'HEADER':
          this.templateComponents.header = component;
          break;
        case 'BODY':
          this.templateComponents.body = component;
          const bodyMatches = component.text && component.text.match(/\{\{\d+\}\}/g) || [];
          this.bodyVariables = new Array(bodyMatches.length).fill('');
          break;
        case 'BUTTONS':
          this.templateComponents.buttons = component;
          let buttonVariableCount = 0;
          if (component.buttons && Array.isArray(component.buttons)) {
            component.buttons.forEach((button: any) => {
              const url = button.button_url || button.url || '';
              if (url.includes('{{')) {
                const matches = url.match(/\{\{\d+\}\}/g) || [];
                buttonVariableCount += matches.length;
              }
            });
          }
          this.buttonVariables = new Array(buttonVariableCount).fill('');
          break;
        case 'FOOTER':
          this.templateComponents.footer = component;
          break;
      }
    });

    this.variables = [...this.bodyVariables, ...this.buttonVariables];
  }

  updatePreview() {
    if (this.previewTimeout) {
      clearTimeout(this.previewTimeout);
    }

    this.previewTimeout = setTimeout(() => {
      if (!this.selectedTemplate || !this.templateComponents.body) {
        this.previewText = '';
        return;
      }

      let bodyText = this.templateComponents.body.text || '';
      this.bodyVariables.forEach((variable, index) => {
        const placeholder = `{{${index + 1}}}`;
        const value = variable.trim() || `{{${index + 1}}}`;
        bodyText = bodyText.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
      });

      this.previewText = bodyText;
    }, 500);
  }

  onVariableChange() {
    this.updatePreview();
  }

  onImageTypeChange(type: 'upload' | 'url') {
    this.imageUploadType = type;
    if (type === 'upload') {
      this.headerImageUrl = '';
      this.uploadedImageUrl = '';
    } else {
      this.selectedImageFile = null;
      this.uploadedImageUrl = '';
      this.imageUploadProgress = 0;
    }
  }

  onImageUrlChange() {
    this.headerImage = this.headerImageUrl;
  }

  getCurrentTime(): string {
    const now = new Date();
    return now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  onImageFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedImageFile = file;
      this.uploadImage(file);
    }
  }

  onContactFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.uploadErrors = [];
      this.selectedFile = file;
      this.parseContactFile(file);
    }
  }

  parseContactFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = e.target.result;
      if (file.name.endsWith('.csv')) {
        this.parseCSV(data);
      } else {
        this.parseExcel(data);
      }
    };

    if (file.name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  }

  parseCSV(data: string) {
    const lines = data.split('\n');
    this.contactsPreview = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (line) {
        const phone = line.split(',')[0].trim();
        if (phone) {
          this.contactsPreview.push({ phone: phone, index: i });
        }
      }
    }
    this.showContactsPreview = this.contactsPreview.length > 0;
  }

  parseExcel(data: any) {
    const XLSX = (window as any).XLSX;
    if (!XLSX) {
      this._flashMessagesService.show('Excel library not loaded', { cssClass: 'alert-danger' });
      return;
    }

    const workbook = XLSX.read(data, { type: 'binary' });
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

    this.contactsPreview = [];
    for (let i = 1; i < jsonData.length; i++) {
      const row: any = jsonData[i];
      if (row[0]) {
        this.contactsPreview.push({ phone: row[0].toString(), index: i });
      }
    }
    this.showContactsPreview = this.contactsPreview.length > 0;
  }

  uploadImage(file: File) {
    if (!this.selectedTemplate) {
      this._flashMessagesService.show('Please select a template first', { cssClass: 'alert-danger' });
      return;
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('salon_id', this.currentUser.salon_id);
    formData.append('template_id', this.selectedTemplate.template_id);

    this.imageUploadProgress = 10; // Show some initial progress

    this.loginservice.uploadWhatsAppImage(formData, this.currentUser).subscribe(
      (response: any) => {
        if (response.status === 'success') {
          this.uploadedImageUrl = response.url;
          this.headerImage = this.uploadedImageUrl;
          this.imageUploadProgress = 100;
          this._flashMessagesService.show('Image uploaded successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show('Image upload failed', { cssClass: 'alert-danger' });
          this.imageUploadProgress = 0;
        }
      },
      error => {
        this._flashMessagesService.show('Image upload failed', { cssClass: 'alert-danger' });
        this.imageUploadProgress = 0;
      }
    );
  }

  // asdsad

  downloadSample() {
    const csvContent = "Phone Number\n9876543XXX\n9874561XXX";
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'whatsapp_sample.csv';
    a.click();
  }

  sendBulkMessages() {
    if (!this.selectedFile || !this.selectedTemplate) {
      this._flashMessagesService.show('Please select template and file', { cssClass: 'alert-danger' });
      return;
    }

    if (!this.campaignName) {
      this._flashMessagesService.show('Please Fill Campaign Name', { cssClass: 'alert-danger' });
      return;
    }

    const totalVariables = this.bodyVariables.length + this.buttonVariables.length;
    if (totalVariables > 0) {
      const emptyBodyVars = this.bodyVariables.filter(v => !v || !v.trim()).length;
      const emptyButtonVars = this.buttonVariables.filter(v => !v || !v.trim()).length;

      if (emptyBodyVars > 0 || emptyButtonVars > 0) {
        this._flashMessagesService.show('Please fill all template variables', { cssClass: 'alert-danger' });
        return;
      }
    }

    if (this.contactsPreview.length === 0) {
      this._flashMessagesService.show('No contacts found in uploaded file', { cssClass: 'alert-danger' });
      return;
    }

    this.showConfirmModal = true;
  }

  confirmSend() {
    this.showConfirmModal = false;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('campaignName', this.campaignName);
    formData.append('templateName', this.selectedTemplate.template_name);
    formData.append('templateId', this.selectedTemplate.template_id);
    formData.append('language', this.selectedTemplate.language);
    formData.append('bodyVariables', JSON.stringify(this.bodyVariables));
    formData.append('buttonVariables', JSON.stringify(this.buttonVariables));
    formData.append('components', JSON.stringify(this.templateComponents));

    if (this.templateComponents.header && this.templateComponents.header.format === 'IMAGE') {
      if (this.imageUploadType === 'url' && this.headerImageUrl) {
        formData.append('headerImageUrl', this.headerImageUrl);
      } else if (this.imageUploadType === 'upload' && this.uploadedImageUrl) {
        formData.append('headerImageUrl', this.uploadedImageUrl);
      }
    }

    this.loginservice.sendBulkWhatsApp(formData, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show(`Sent ${data['sent']} messages`, { cssClass: 'alert-success' });
          this.currentUser.credits = data['updatedCredit'];
          this.loginservice.setLocalSession(this.currentUser, 'currentUser');
          this.resetForm();
        } else if (data['status'] === 'exist') {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
        } else if (data['status'] === 'invalidNumber') {
          this.uploadErrors = data['errors'];
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-success' });
        } else if (data['status'] === 'low') {
          this.currentUser.credits = data['updatedCredit'];
          this.loginservice.setLocalSession(this.currentUser, 'currentUser');
          this._flashMessagesService.show(data['msg'], { cssClass: 'alert-success' });
          alert(data['msg']);
        } else {
          this._flashMessagesService.show('Failed to send messages', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error sending messages', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }

  resetForm() {
    this.selectedTemplate = null;
    this.selectedFile = null;
    this.selectedImageFile = null;
    this.campaignName = '';
    this.bodyVariables = [];
    this.buttonVariables = [];
    this.variables = [];
    this.headerImageUrl = '';
    this.uploadedImageUrl = '';
    this.headerImage = '';
    this.imageUploadProgress = 0;
    this.previewText = '';
    this.contactsPreview = [];
    this.showContactsPreview = false;
    this.templateComponents = {
      header: null,
      body: null,
      buttons: null,
      footer: null
    };

    const fileInputs = document.querySelectorAll('input[type="file"]');
    for (let i = 0; i < fileInputs.length; i++) {
      (fileInputs[i] as HTMLInputElement).value = '';
    }
  }

  cancelSend() {
    this.showConfirmModal = false;
  }


  hasHeaderImage(): boolean {
    return this.templateComponents.header && this.templateComponents.header.format === 'IMAGE';
  }

  hasButtons(): boolean {
    return !!this.templateComponents.buttons;
  }

  getButtonsData(): any[] {
    if (!this.templateComponents.buttons) return [];

    if (this.templateComponents.buttons.buttons && Array.isArray(this.templateComponents.buttons.buttons)) {
      return this.templateComponents.buttons.buttons.map((button: any) => ({
        text: button.button_text || button.text,
        type: button.button_type || button.type,
        url: button.button_url || button.url,
        phone_number: button.phone_number
      }));
    }

    if (this.templateComponents.buttons.example && Array.isArray(this.templateComponents.buttons.example)) {
      return this.templateComponents.buttons.example;
    }

    return [];
  }

  getButtonUrlSample(index: number): string {
    if (!this.templateComponents.buttons || !this.templateComponents.buttons.buttons) return '';

    const buttons = this.templateComponents.buttons.buttons;
    let currentVarIndex = 0;

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      const url = button.button_url || button.url || '';

      if (url.includes('{{')) {
        if (currentVarIndex === index) {
          return url;
        }
        currentVarIndex++;
      }
    }

    return '';
  }
}


// WEBPACK FOOTER //
// ./src/app/bulk-whatsapp/bulk-whatsapp.component.ts